import { useQuery } from 'react-query';

import { DocChronologySummary } from '../../../../backend/src/matter/subset/chronology/doc-chronology/dto/get-doc-chronologies-response.dto';
import { APIBaseChronos } from '@/api/hosts';
import { QueryEntity } from '@/api/types';
import useGetFetchConfig from '@/api/useGetFetchConfig';

export const useGetDocChronologies = ({ matterId, subsetId }: { matterId: string; subsetId: string }) => {
  const { fetchConfigGET } = useGetFetchConfig();

  return useQuery<DocChronologySummary[]>(
    [QueryEntity.DocChronologies, { subsetId }],
    async () => {
      const res = await fetch(
        `${APIBaseChronos}/api/matter/${matterId}/subset/${subsetId}/doc-chronology`,
        fetchConfigGET,
      );
      if (!res.ok) {
        throw new Error(`Failed to fetch doc chronologies: ${res.status}`);
      }
      return res.json();
    },
    { enabled: !!matterId && !!subsetId },
  );
};
